// Подключение VUE.JS и плагинов
import Vue from 'vue'

// VUEX
import Vuex from 'vuex'
// Router
import VueRouter from 'vue-router'
// Vue bootstrap
import BootstrapVue from 'bootstrap-vue'
// Стили Bootstrap
import '@/assets/bootstrap/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Свой стиль оформления
import '@/assets/style.css'

// Маска
import VueTheMask from 'vue-the-mask'
// Печать
import VueHtmlToPaper from 'vue-html-to-paper'
// Нотификации
import Notifications from 'vue-notification'
// Axios
import axios from 'axios'
import App from './App.vue'


// Vue Excel
import JsonExcel from "vue-json-excel";


// Хранилице VUEX
import state from '@/store/state.js'
import getters from '@/store/getters.js'
import mutations from '@/store/mutations.js'


Vue.use(Vuex)

Vue.use(VueRouter)

// Google Adsense
import Ads from 'vue-google-adsense'
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

Vue.use(BootstrapVue)

Vue.use(VueTheMask)

Vue.use(VueHtmlToPaper)

Vue.use(Notifications)

Vue.component("downloadExcel", JsonExcel);

// Локальные компоненты
import MainDefault from "@/components/main/Default";
import SalaryDefault from "@/components/salary/Default";
import SalaryCalculator from "@/components/salary/Calculator";
import SalarySums from "@/components/salary/Sums";
import Site from "@/components/sites/Site";
import Reviews from "@/components/sites/Reviews";
import Support from "@/components/sites/Support";
import AdditionalCharges from "@/components/salary/AdditionalCharges";
import AdditionalCalcs from "@/components/salary/AdditionalCalcs";

import RegistersDefault from "@/components/registers/Default"
import RegistersOrganizations from "@/components/registers/Organizations"
import RegistersWorkers from "@/components/registers/Workers"
import RegistersGroups from "@/components/registers/Groups"

import DocsDefault from "@/components/docs/Default"
import DocsSalaryCertificate from "@/components/docs/SalaryCertificate"
import DocsPayslip from "@/components/docs/Payslip"

import BankDefault from "@/components/bank/Default"
import BankSwift from "@/components/bank/Swift"

import ReportsDefault from "@/components/reports/Default"
import ReportsForm20000 from "@/components/reports/Form200.00"
import ReportsForm2002020 from "@/components/reports/Form200"
import ReportsForm91000 from "@/components/reports/Form910.00"
import ReportsForm92000 from "@/components/reports/Form920.00"


const routes = [

    //{path: '/', name: 'home', component: MainDefault, props: (route) => ({refid: route.query.r})},
    {path: '/salary/', name: 'SalaryDefault', component: SalaryDefault, props: (route) => ({refid: route.query.r})},
    //{path: '/salary/calculator/', name: 'SalaryCalculator', component: SalaryCalculator, props: (route) => ({refid: route.query.r})},
    {path: '/', name: 'SalaryCalculator', component: SalaryCalculator, props: (route) => ({refid: route.query.r})},
    {path: '/salary/sums/', name: 'SalarySums', component: SalarySums, props: (route) => ({refid: route.query.r})},
    {path: '/salary/additionalcharges/', name: 'AdditionalCharges', component: AdditionalCharges, props: (route) => ({refid: route.query.r})},
    {path: '/salary/additionalcalcs/', name: 'AdditionalCalcs', component: AdditionalCalcs, props: (route) => ({refid: route.query.r})},
    {path: '/registers/', name: 'RegistersDefault', component: RegistersDefault, props: (route) => ({refid: route.query.r})},
    {path: '/registers/organizations/', name: 'RegistersOrganizations', component: RegistersOrganizations, props: (route) => ({refid: route.query.r})},
    {path: '/registers/workers/', name: 'RegistersWorkers', component: RegistersWorkers, props: (route) => ({refid: route.query.r})},
    {path: '/registers/groups/', name: 'RegistersGroups', component: RegistersGroups, props: (route) => ({refid: route.query.r})},
    {path: '/docs/', name: 'DocsDefault', component: DocsDefault, props: (route) => ({refid: route.query.r})},
    {path: '/docs/salarycertificate', name: 'DocsSalaryCertificate', component: DocsSalaryCertificate, props: (route) => ({refid: route.query.r})},
    {path: '/docs/payslip', name: 'DocsPayslip', component: DocsPayslip, props: (route) => ({refid: route.query.r})},
    {path: '/bank/', name: 'BankDefault', component: BankDefault, props: (route) => ({refid: route.query.r})},
    {path: '/bank/swift', name: 'BankSwift', component: BankSwift, props: (route) => ({refid: route.query.r})},
    {path: '/reports/', name: 'ReportsDefault', component: ReportsDefault, props: (route) => ({refid: route.query.r})},
    {path: '/reports/200.00/', name: 'ReportsForm20000', component: ReportsForm20000, props: (route) => ({refid: route.query.r})},
    {path: '/reports/200-2020/', name: 'ReportsForm2002020', component: ReportsForm2002020, props: (route) => ({refid: route.query.r})},
    {path: '/reports/910.00/', name: 'ReportsForm91000', component: ReportsForm91000, props: (route) => ({refid: route.query.r})},
    {path: '/reports/920.00/', name: 'ReportsForm92000', component: ReportsForm92000, props: (route) => ({refid: route.query.r})},
    {path: '/info/description/', name: 'description', component: Site, props: (route) => ({refid: route.query.r, id: 1})},
    {path: '/info/price/', name: 'price', component: Site, props: (route) => ({refid: route.query.r, id: 2})},
    {path: '/info/newprice/', name: 'newprice', component: Site, props: (route) => ({refid: route.query.r, id: 7})},
    {path: '/info/changes/', name: 'changes', component: Site, props: (route) => ({refid: route.query.r, id: 3})},
    {path: '/info/actions/', name: 'actions', component: Site, props: (route) => ({refid: route.query.r, id: 6})},
    {path: '/info/reviews/', name: 'reviews', component: Reviews, props: (route) => ({refid: route.query.r})},
]

// Маршрутизация
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes
})

const store = new Vuex.Store({
    state,
    getters,
    mutations
});

Vue.config.productionTip = false

// Прототипы
Vue.prototype.$http = axios;
Vue.prototype.$apiold = 'https://culs.kz/apiold/';

// Новый API на api.culs.kz, зеркало api.dsb.kz для переноса всех данных в БД dsb_kz 6 марта 2023 года
Vue.prototype.$api = 'https://api.culs.kz';

Vue.prototype.$printstyle_portrait = ['https://culs.kz/calc/css/bootstrap/bootstrap.css', 'https://culs.kz/calc/css/print.css?' + Math.random(), 'https://culs.kz/calc/css/portrait.css'];
Vue.prototype.$printstyle_landscape = ['https://culs.kz/calc/css/bootstrap/bootstrap.css', 'https://culs.kz/calc/css/print.css?' + Math.random(), 'https://culs.kz/calc/css/landscape.css'];

// Миксины
Vue.mixin({
    methods: {
        async getOrgs(mode) {
            const response = await this.$http
                .post(this.$apiold, {
                    task: 'orgs',
                    mode: mode,
                })
            if (typeof response.data.result !== 'undefined') {
                return response.data.result;
            }
            else {
                return false;
            }
        },
        async getWorkers(mode, org_id) {
            const response = await this.$http
                .post(this.$apiold, {
                    task: 'workers',
                    mode: mode,
                    org_id: org_id
                })
            if (typeof response.data.result !== 'undefined') {
                return response.data.result;
            }
            else {
                return false;
            }
        },

        setOrgs: function() {
            this.$store.commit('wait', {state: true, name: 'Загрузка справочника организаций'});
            this.getOrgs()
                .then (response => {
                    this.$store.commit('wait', {state: false});

                    if (response.length > 0 && this.$store.state.user.subscribe_type == 'premium') {
                        this.$store.commit('setRegister', {register: 'orgs', list: response});
                    }
                    else {
                        // Справочник пуст, нужны данные по умолчанию.
                        this.getOrgs('default')
                            .then(response => {
                                this.$store.commit('setRegister', {register: 'orgs', default: response});
                            })
                    }
                    this.setWorkers();
                })
        },

        setWorkers: function () {
            this.$store.commit('wait', {state: true, name: 'Загрузка справочника организаций'});

            this.getWorkers('', this.$store.state.registers.orgs.current.id)
                .then (response => {
                    this.$store.commit('wait', {state: false});

                    if (response.length > 0 && this.$store.state.user.subscribe_type == 'premium') {
                        this.$store.commit('setRegister', {register: 'workers', list: response});
                    }
                    else {
                        // Справочник пуст, нужны данные по умолчанию.
                        this.getWorkers('default', this.$store.state.registers.orgs.current.id)
                            .then(response => {
                                this.$store.commit('setRegister', {register: 'workers', default: response});
                            })
                    }
                })
        },





        formatMoney: function (amount, decimalCount = 2, decimal = ".", thousands = ",") {
            try {
                decimalCount = Math.abs(decimalCount);
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? "-" : "";

                let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                let j = (i.length > 3) ? i.length % 3 : 0;

                return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");

            } catch (e) {
                console.log(e)
            }
        },

        getEnumFieldName: function (data, field, id) {
            let res;
            data.forEach(function (item) {
                if (typeof item.options !== 'undefined') {
                    item.options.forEach(function (subitem) {
                        if (subitem.value == id) {
                            res = subitem[field];
                        }
                    })
                } else {
                    if (item.value == id) {
                        res = item[field];
                    }
                }

            })

            return res;
        },
        // Енумераторы
        Enums: function (name, table, first, base, value, group, fields, org_id) {
            this.$http
                .post(this.$apiold, {
                    task: 'enums',
                    name: table,
                    first: first,
                    base: base,
                    group: group,
                    value: value,
                    fields: fields,
                    org_id: org_id
                })
                .then(response => {
                    this.$store.commit('enumChange', {name: name, register: response.data.options});
                });
        },
        // Печать
        //Print: function (type, size) {
        async Print(type, size) {
            var printSize = '';
            switch (size) {
                default:
                    printSize = this.$printstyle_portrait;
                    break;
                case 'landscape':
                    printSize = this.$printstyle_landscape;
                    break;
            }

            await this.$htmlToPaper(type, {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: printSize,
                timeout: 3000

            });
        },

        // Получение данных о банке по ID
        async getDataBank (bank_id) {
            const response = await this.$http
                .post(this.$apiold,{
                    task: 'get-data-bank',
                    bank_id: bank_id
                })
                .catch(function (error) {
                    console.log(error);
                });
            return response.data.result;

        },
        // Подсчет итогов массива
        getAmountField: function (data, field) {
            var amount = 0;
            data.forEach(function (item) {
                if (!isNaN(item[field])) {
                    if ((typeof item.selected !== 'undefined' && Number(item.selected) == 1) || typeof item.selected === 'undefined') {
                        amount += Number(item[field]);
                    }
                }
            });
            return amount;
        },
        // Месяц из цифры в строку
        getMonthName: function (month) {
            let res = '';
            switch (month) {
                case '01':
                    res = 'январь';
                    break;
                case '02':
                    res = 'февраль';
                    break;
                case '03':
                    res = 'март';
                    break;
                case '04':
                    res = 'апрель';
                    break;
                case '05':
                    res = 'май';
                    break;
                case '06':
                    res = 'июнь';
                    break;
                case '07':
                    res = 'июль';
                    break;
                case '08':
                    res = 'август';
                    break;
                case '09':
                    res = 'сентябрь';
                    break;
                case '10':
                    res = 'октябрь';
                    break;
                case '11':
                    res = 'ноябрь';
                    break;
                case '12':
                    res = 'декабрь';
                    break;
                case '1q':
                    res = 'I квартал';
                    break;
                case '2q':
                    res = 'II квартал';
                    break;
                case '3q':
                    res = 'III квартал';
                    break;
                case '4q':
                    res = 'IV квартал';
                    break;
            }
            return res;
        },
        getDate(date) {
            var date2 = '';
            if (date.length == 10) {
                date = date.split('-');
                date2 = date[2] + '.' + date[1] + '.' + date[0];
            }
            return date2;
        }

    }
});

// Приложение
new Vue({
    components: {
        MainDefault,

        SalaryDefault,
        SalaryCalculator,
        SalarySums,
        AdditionalCharges,
        AdditionalCalcs,

        // Справочники
        RegistersDefault,
        RegistersOrganizations,
        RegistersWorkers,
        RegistersGroups,

        DocsDefault,
        DocsSalaryCertificate,
        DocsPayslip,

        BankDefault,

        ReportsDefault,
        ReportsForm20000,
        ReportsForm2002020,
        ReportsForm91000,

        Site, Reviews, Support
    },
    router,
    store: store,
    render: h => h(App)
}).$mount('#app')

